import { Model, Factory, hasMany, belongsTo } from 'miragejs'
import { randPhrase, randBoolean } from '@ngneat/falso'
import { pageable, filterable } from './utils.js'

import type { ModelDefinition } from 'miragejs/-types'
import type { SchemaAttributes } from '../types'
import type { MirageServer, MockServer } from './server'

export type WardData = SchemaAttributes<'Ward'>

export const model = (Model as ModelDefinition<WardData>).extend({
  consultations: hasMany(),
  department: belongsTo('department'),
})

export const factory = Factory.extend<WardData>({
  name() {
    return randPhrase({ maxCharCount: 60 })
  },
  code() {
    return randPhrase({ maxCharCount: 40 })
  },
  is_active() {
    return randBoolean()
  },
})

export function routes(server: MockServer) {
  server.resource('ward')

  server.get('/wards', function (this: MirageServer, schema, request) {
    const wards = schema.all('ward')

    const filtered = filterable(wards, request, {
      search: (item, value) =>
        item.attrs.name?.toLowerCase().includes(value.toLowerCase()),
      is_active: (item, value) => item.is_active === (value === 'true'),
      'department.id': (item, value) => item.department_id === value,
    })

    const { data, meta } = pageable(filtered, request)

    return {
      ...this.serialize(data),
      meta: {
        pagination: meta,
      },
    }
  })
}

export function seeds(server: MockServer) {
  server.schema.all('department').models.forEach((department) => {
    server.createList('ward', 10, { department_id: department.id })
  })
}
